__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "inference-history";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "18.0.0", () => (__webpack_require__.e(681).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 6443))))));
			register("@angular/common", "18.0.0", () => (__webpack_require__.e(554).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 316))))));
			register("@angular/core/primitives/event-dispatch", "18.0.0", () => (__webpack_require__.e(126).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives/event-dispatch.mjs */ 6745))))));
			register("@angular/core/primitives/signals", "18.0.0", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/primitives/signals.mjs */ 5689))))));
			register("@angular/core", "18.0.0", () => (__webpack_require__.e(199).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 7580))))));
			register("@angular/forms", "18.0.0", () => (__webpack_require__.e(313).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/forms/fesm2022/forms.mjs */ 4456))))));
			register("@angular/platform-browser", "18.0.0", () => (__webpack_require__.e(674).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/platform-browser/fesm2022/platform-browser.mjs */ 436))))));
			register("@angular/router", "18.0.0", () => (__webpack_require__.e(310).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 5072))))));
			register("@videogular/ngx-videogular/core", "10.0.1", () => (__webpack_require__.e(203).then(() => (() => (__webpack_require__(/*! ./node_modules/@videogular/ngx-videogular/fesm2022/videogular-ngx-videogular-core.mjs */ 2441))))));
			register("@videogular/ngx-videogular/streaming", "10.0.1", () => (__webpack_require__.e(749).then(() => (() => (__webpack_require__(/*! ./node_modules/@videogular/ngx-videogular/fesm2022/videogular-ngx-videogular-streaming.mjs */ 9892))))));
			register("hls.js", "1.6.16", () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(/*! ./node_modules/hls.js/dist/hls.mjs */ 1295))))));
			register("marked", "14.1.4", () => (__webpack_require__.e(378).then(() => (() => (__webpack_require__(/*! ./node_modules/marked/lib/marked.esm.js */ 997))))));
			register("mqtt", "5.3.4", () => (__webpack_require__.e(192).then(() => (() => (__webpack_require__(/*! ./node_modules/mqtt/dist/mqtt.esm.js */ 4049))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e(600).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/operators/index.js */ 8219))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e(226).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/dist/esm/index.js */ 845))))));
			register("shared-utils", "0.0.1", () => (__webpack_require__.e(876).then(() => (() => (__webpack_require__(/*! ./projects/shared-utils/src/public-api.ts */ 9871))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};